export {default} from './RankProgressCard.connect';
